import React from "react";
import ZeroTrustPolicies from "components/newDesign/zeroTrust/ZeroTrustPolicies";

const ZeroTrustPoliciesPage = () => {
  return <ZeroTrustPolicies />;
};

export default ZeroTrustPoliciesPage;
